export const Citations = {
	"1": {
		link:'http://articles.latimes.com/1986-10-23/news/mn-7068_1_ballot-measures' ,
		publication:"LA Times (1986!)",
		headline:"The Lone Dissenter Rides Again",
		directQuote:"\"I'm certain that people who see no opposition argument at all (to a ballot measure) very often will believe that there's no legitimate argument to make against it,\" he said.",
	},
	"2": {
		link:"http://voterguide.sos.ca.gov/propositions/71/arguments-rebuttals.htm",
		publication:"The State of California",
		headline:"The official CA voter guide",
		directQuote:"There is some danger in this measure that the State Legislature could, in the future and by its own enactment, delay how long the Secretary of State may take to declare the outcome of elections on measures (currently 38 days) and thereby undermine the process.",
	},
	"3": {
		link:"http://www.latimes.com/opinion/endorsements/la-ed-endorsement-prop-71-20180418-story.html",
		publication:"LA Times",
		headline:"Say yes to Prop 71 and to ballot sanity",
		directQuote:"The measure was winning the day after the election and was deemed by pundits and pollsters to have passed — even though county elections officials were still processing thousands of ballots and the outcome wasn't officially certified until December. "
	},
	"4": {
		link:"http://voterguide.sos.ca.gov/propositions/71/arguments-rebuttals.htm",
		publication:"The State of California",
		headline:"The official CA voter guide",
		directQuote:"Under California law, all changes to the Constitution must be approved by the voters. The Legislature cannot, on its own, delay implementation of voter enacted initiatives. In 1970, no one anticipated the growth in votes being cast by mail as we are seeing today. Proposition 71 is a minor, simple fix intended to clarify existing law.",
	},
}


// WEBPACK FOOTER //
// ./src/pages/june-5/props/data/71/expandables.js